export default "__VITE_ASSET__C72ucL8k__"